<template>
  <v-fab-transition>
    <v-btn
      v-scroll="onScroll"
      v-show="show"
      :style="{ bottom: $vuetify.breakpoint.smOnly ? '64px' : '' }"
      dark
      color="primary"
      fab
      fixed
      bottom
      right
      @click="toTop"
    >
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
  </v-fab-transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  methods: {
    onScroll() {
      if (typeof window === 'undefined') return;

      const top = window.pageYOffset ||
          document.documentElement.offsetTop ||
          0;

      this.show = top > 300;
    },
    toTop() {
      this.$router.push({ hash: '' });
      this.$vuetify.goTo(0);
    },
  },
};
</script>

<style scoped>

</style>
